import styled from "styled-components";

export const ViewerFeed = styled.div`
	width: 100%;
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;

export const ContentContainer = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding: 1rem;
`;
